module.exports = __webpack_public_path__ + "img/tarj-mi-entretenimiento.e49114d6.png";